import './home.css';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../context/UserContext';
import { CatalogAPI, OffersAPI } from '../api';

export default function RequestOffer() {
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [services, setServices] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]); // [{id, mode}]
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [note, setNote] = useState('');
  const [budget, setBudget] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submittedId, setSubmittedId] = useState(null);
  // Contact fields
  const [contactType, setContactType] = useState('b2c');
  const [companyName, setCompanyName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [street, setStreet] = useState('');
  const [zip, setZip] = useState('');
  const [city, setCity] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [vatId, setVatId] = useState('');

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        setError(''); setLoading(true);
        const { services, packages } = await CatalogAPI.get();
        if (!active) return;
        setServices(Array.isArray(services) ? services : []);
        setPackages(Array.isArray(packages) ? packages : []);
      } catch (e) {
        if (!active) return;
        setError('Katalog konnte nicht geladen werden');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const toggleService = (id) => {
    setSelectedServices(prev => {
      const found = prev.find(x => x.id === id);
      if (found) return prev.filter(x => x.id !== id);
      return [...prev, { id, mode: 'once' }];
    });
  };
  const changeServiceMode = (id, mode) => {
    setSelectedServices(prev => prev.map(x => x.id === id ? { ...x, mode } : x));
  };
  const togglePackage = (id) => {
    setSelectedPackages(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (selectedServices.length === 0 && selectedPackages.length === 0) {
      alert('Bitte wähle mindestens eine Dienstleistung oder ein Paket.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await OffersAPI.request({
        serviceSelections: selectedServices.map(x => ({ serviceId: x.id, mode: x.mode })),
        packageIds: selectedPackages,
        note,
        budget,
        contactType,
        companyName,
        firstName,
        lastName,
        street,
        zip,
        city,
        email,
        phone,
        vatId,
      });
      setSubmittedId(res?.id || 0);
    } catch (e) {
      const msg = e?.response?.data?.error || e?.message || 'Anfrage fehlgeschlagen';
      alert(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="home-page" style={{ padding: 24 }}>
      <section id="top" className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Individuelles Angebot anfordern</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Wähle einzelne Dienstleistungen (einmalig oder als Abo) oder komplette Pakete (Abo) aus und teile uns deine Wünsche mit.</p>
      </section>
      <section style={{ width:'100%', maxWidth:1200, margin:'0 auto', padding:'0 16px 40px 16px' }}>
        {loading && <p>Lade Katalog…</p>}
        {error && <p style={{ color:'#ef4444' }}>{error}</p>}
        {!loading && !submittedId && (
          <form onSubmit={submit} style={{ display:'grid', gridTemplateColumns:'1fr 360px', gap:24, alignItems:'start' }}>
            <div>
              <h3 style={{ margin:'8px 0 8px' }}>Kontaktdaten</h3>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:10 }}>
                <label style={{ display:'flex', flexDirection:'column', fontSize:12 }}>Typ
                  <select value={contactType} onChange={e => setContactType(e.target.value)}>
                    <option value="b2c">Privat (B2C)</option>
                    <option value="b2b">Geschäftlich (B2B)</option>
                  </select>
                </label>
                {contactType === 'b2b' && (
                  <label style={{ display:'flex', flexDirection:'column', fontSize:12 }}>Firmenname
                    <input value={companyName} onChange={e => setCompanyName(e.target.value)} required={contactType==='b2b'} />
                  </label>
                )}
                <label style={{ display:'flex', flexDirection:'column', fontSize:12 }}>Vorname
                  <input value={firstName} onChange={e => setFirstName(e.target.value)} required />
                </label>
                <label style={{ display:'flex', flexDirection:'column', fontSize:12 }}>Nachname
                  <input value={lastName} onChange={e => setLastName(e.target.value)} required />
                </label>
                <label style={{ display:'flex', flexDirection:'column', fontSize:12 }}>Straße & Hausnr.
                  <input value={street} onChange={e => setStreet(e.target.value)} required />
                </label>
                <label style={{ display:'flex', flexDirection:'column', fontSize:12 }}>PLZ
                  <input value={zip} onChange={e => setZip(e.target.value)} required />
                </label>
                <label style={{ display:'flex', flexDirection:'column', fontSize:12 }}>Ort
                  <input value={city} onChange={e => setCity(e.target.value)} required />
                </label>
                <label style={{ display:'flex', flexDirection:'column', fontSize:12 }}>E-Mail
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
                </label>
                <label style={{ display:'flex', flexDirection:'column', fontSize:12 }}>Telefon (optional)
                  <input value={phone} onChange={e => setPhone(e.target.value)} />
                </label>
                {contactType === 'b2b' && (
                  <label style={{ display:'flex', flexDirection:'column', fontSize:12 }}>USt-ID
                    <input value={vatId} onChange={e => setVatId(e.target.value)} required={contactType==='b2b'} />
                  </label>
                )}
              </div>
              <h3 style={{ margin:'8px 0 8px' }}>Dienstleistungen</h3>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))', gap:10 }}>
                {services.map(s => {
                  const sel = selectedServices.find(x => x.id === s.id);
                  return (
                    <div key={s.id} style={{ display:'flex', gap:10, alignItems:'flex-start', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:10 }}>
                      <input type="checkbox" checked={!!sel} onChange={() => toggleService(s.id)} />
                      <div style={{ display:'flex', flexDirection:'column', flex:1 }}>
                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:8 }}>
                          <div style={{ fontWeight:600 }}>{s.name}</div>
                          {sel && (
                            <select value={sel.mode} onChange={e => changeServiceMode(s.id, e.target.value)} title="Auswahl: einmalig oder Abo">
                              <option value="once">einmalig</option>
                              <option value="subscription">Abo</option>
                            </select>
                          )}
                        </div>
                        {s.description && <div style={{ fontSize:12, opacity:.8 }}>{s.description}</div>}
                      </div>
                    </div>
                  );
                })}
                {services.length === 0 && <p style={{ opacity:.7 }}>Keine aktiven Dienstleistungen verfügbar.</p>}
              </div>
              <h3 style={{ margin:'20px 0 8px' }}>Pakete</h3>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))', gap:10 }}>
                {packages.map(p => (
                  <label key={p.id} style={{ display:'flex', gap:10, alignItems:'flex-start', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:10 }}>
                    <input type="checkbox" checked={selectedPackages.includes(p.id)} onChange={() => togglePackage(p.id)} />
                    <div style={{ display:'flex', flexDirection:'column' }}>
                      <div style={{ fontWeight:600 }}>{p.name}</div>
                      {p.description && <div style={{ fontSize:12, opacity:.8 }}>{p.description}</div>}
                    </div>
                  </label>
                ))}
                {packages.length === 0 && <p style={{ opacity:.7 }}>Keine aktiven Pakete verfügbar.</p>}
              </div>
            </div>
            <div style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:14, position:'sticky', top:18 }}>
              <h3 style={{ margin:'0 0 10px', fontSize:18 }}>Deine Wünsche</h3>
              <label style={{ display:'flex', flexDirection:'column', fontSize:12 }}>Anmerkungen / Wünsche (optional)
                <textarea rows={6} value={note} onChange={e => setNote(e.target.value)} placeholder="Beschreibe kurz, was du dir vorstellst." />
              </label>
              <label style={{ display:'flex', flexDirection:'column', fontSize:12, marginTop:8 }}>Budget / Preisrahmen (optional)
                <input value={budget} onChange={e => setBudget(e.target.value)} placeholder="z.B. 200–300 € / Monat" />
              </label>
              <div style={{ marginTop:12 }}>
                <button type="submit" disabled={submitting} className="btn btn-primary btn-sm">{submitting ? 'Sende…' : 'Angebot anfordern'}</button>
              </div>
            </div>
          </form>
        )}
        {submittedId && (
          <div style={{ background:'#0b1220', border:'1px solid #334155', borderRadius:16, padding:20 }}>
            <h3 style={{ margin:'0 0 8px' }}>Danke! Deine Anfrage ist eingegangen.</h3>
            <p>Unser Team meldet sich zeitnah mit einem individuellen Angebot.</p>
          </div>
        )}
      </section>
    </div>
  );
}
